<template>
    <div class="value-group-box">
        <div
                class="value-group"
                v-for="(values, name) in valueGroups"
                :key="name + '_' + values.length"
                :class="expanded[name] ? 'value-group-expanded' : 'value-group-collapsed'"
        >
            <div
                v-if="name !== '__counts'"
                class="value-group-header"
                @click="toggleCollapse(name)"
            >{{name}} ({{ values.length }}/{{ valueCounts[name] }})</div>
            <div
                v-show="name !== '__counts' && expanded[name]"
                class="value-group-element"
                v-for="value in values"
                :key="name + '_' + value"
                @click="$emit('onEdit')"
            >{{value}}</div>
        </div>
        <div
            v-if="Object.keys(valueGroups).length === 0"
            @click="$emit('onEdit')"
        >{{$t('-- please select --')}}</div>
    </div>
</template>

<script>
    export default {
        name: "GroupedTableCell",
        props: {
            groups: Object,
            initialExpandLimit: {
                type:     Number,
                required: false,
                default:  20
            }
        },
        data() {
            return {
                expanded: {},
                valueCounts: this.groups.__counts,
                valueGroups: (function() {
                    let groups = Object.assign({}, this.groups);
                    delete groups.__counts;
                    return groups;
                }).bind(this)(),
            }
        },
        methods: {
            computeExpanded() {
                let count = 0;
                for (let name in this.groups) {
                    if (name === '__counts') {
                        continue;
                    }
                    count += this.groups[name].length;
                }

                let expanded = {};
                let groupState = count < this.initialExpandLimit;

                for (let name in this.groups) {
                    expanded[name] = groupState;
                }

                this.expanded = expanded;
            },
            toggleCollapse(name) {
                this.$set(this.expanded, name, !this.expanded[name]);
            }
        },
        created() {
            this.computeExpanded();
        }
    }
</script>

<style scoped>
    div.value-group-box {

    }
    div.value-group-box > div.value-group {

    }
    div.value-group-box > div.value-group > div.value-group-header {
        color: var(--toolbar-label);
        padding: 0 0 0 20px;
        background-position: left center;
        background-size: 16px;
        cursor: pointer;
    }
    div.value-group-box > div.value-group.value-group-expanded:not(:last-child) {
        margin-bottom: 8px;
    }
    div.value-group-box > div.value-group.value-group-collapsed > div.value-group-header {
        background-image: url('../../assets/icons/table/arrow_down.svg');
    }
    div.value-group-box > div.value-group.value-group-expanded > div.value-group-header {
        background-image: url('../../assets/icons/table/arrow_up.svg');
    }
    div.value-group-box > div.value-group > div.value-group-element {
        padding-left: 10px;
        text-overflow: ellipsis;
        max-height: 16px;
        overflow: hidden;
        white-space: nowrap;
        max-width: 93%;
    }
    div.value-group-box > div.value-group.value-group-collapsed > div.value-group-element {
        display: none;
    }
</style>